module.exports = __webpack_public_path__ + "assets/404b4a2a5183865752f2ab883ba86f41.mp4";